<template>
  <el-dialog
    title="添加考试"
    width="40%"
    :before-close="handleClose"
    :visible.sync="isOpen"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" label-width="70px" :rules="rules" @submit.native.prevent="sure">
      <el-form-item label="考试码" prop="code">
        <el-input v-model="form.code" placeholder="请输入考试码参与考试" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="handleClose">取 消</el-button>
      <el-button class="sure" type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    addVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        code: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入考试码', trigger: 'blur' }
        ] }
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.addVisible;
      },
      set(val) {
        this.$emit("update:addVisible", val);
      }
    }
  },
  methods: {
    handleClose() {
      this.form.code = ''
      this.isOpen = false;
    },
    sure() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('setCode', this.form.code)
          this.form.code = ''
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
